import React from 'react';
import { useSelector } from 'react-redux';
import {
  Collapse,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import SearchTopBar from '../SearchTopBar';
import ListData from '../ListData';
import { fetchSelectedAlmacen } from '../../../../redux/actions/expensesActions';

const Almacen = ({
  type,
  fetchData,
}) => {
  React.useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const list = useSelector(state => state.gastos.listaAlmacen);
  const loads = useSelector(state => state.loads);
  return (
    <div>
      <SearchTopBar type={type} />
      { loads.updateIsLoading && (
        <Collapse in={loads.updateIsLoading}>
          <LinearProgress />
        </Collapse>
      )}
      { !loads.updateIsLoading && list.data.length === 0 && (
        <Collapse in={!loads.updateIsLoading && list.data.length === 0}>
          <List dense>
            <ListItem classes={{ root: 'bg-white' }}>
              <ListItemText
                primary="Sin proveedores"
                secondary="No cuenta con proveedores"
              />
            </ListItem>
          </List>
        </Collapse>
      )}
      { !loads.updateIsLoading && list.data.length > 0 && (
        <Collapse in={!loads.updateIsLoading && list.data.length > 0}>
          <ListData data={list.data} fetchData={fetchSelectedAlmacen} type={type} />
        </Collapse>
      )}
    </div>
  );
};

export default Almacen;
